var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { DirtyCache, DirtyModel, DirtyProperty } from '../../Core';
import { ErrorCodes, ExceptionHandlerClass } from '../../System/Aop';
var DirtyCacheV5 = (function (_super) {
    __extends(DirtyCacheV5, _super);
    function DirtyCacheV5() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DirtyCacheV5.prototype.change = function (model, property) {
        var _this = this;
        if (property && model.UniqueID && !model.isCoreSynchronizing()) {
            if (this.items.some(function (item) { return item.name === model.UniqueID; })) {
                this.items.filter(function (item) { return item.name === model.UniqueID; }).forEach(function (item) {
                    item.properties.push(new DirtyProperty(_this.getPropertyName(property), _this.getPropertyValue(model, property)));
                });
            }
            else {
                var dirty = new DirtyModel(model.UniqueID, new Array(new DirtyProperty(this.getPropertyName(property), this.getPropertyValue(model, property))));
                dirty.mapperId = model.mapperId;
                this.items.push(dirty);
            }
        }
    };
    DirtyCacheV5.prototype.getChanges = function () {
        var changed = [];
        while (this.items.length > 0) {
            var currentItem = this.items.shift();
            var itemProperties = currentItem.toReduce();
            itemProperties.Id = currentItem.name;
            itemProperties.MapperId = currentItem.mapperId;
            changed.push(itemProperties);
        }
        return changed;
    };
    DirtyCacheV5 = __decorate([
        ExceptionHandlerClass(ErrorCodes.ClientCore)
    ], DirtyCacheV5);
    return DirtyCacheV5;
}(DirtyCache));
export { DirtyCacheV5 };
